import React from "react";
import { Bar } from "react-chartjs-2";
import "../../Assessts/Styles/SamagraDashboard/Participations.scss";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels";


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

// Custom plugin for 75% target line
const GradeWiseParticipation = (props) => {


  const targetLine = {
    id: "targetLine",

    afterDraw(chart) {
      const {
        ctx,
        chartArea: { left, right },
        scales: { y },
      } = chart;

      const yPos = y.getPixelForValue(75);

      ctx.save();

      ctx.beginPath();
      ctx.setLineDash([6, 6]);
      ctx.strokeStyle = "#EF4444";
      ctx.lineWidth = 2;

      ctx.moveTo(left, yPos);
      ctx.lineTo(right, yPos);

      ctx.stroke();
      ctx.restore();
    },
  };

  const labels = [];
  const values = [];

  for (let i = 0; i < props.Data?.length; i++) {
    labels.push(`Grade ${props.Data[i].grade}`);
    values.push(props.Data[i].registered > 0
      ? ((props.Data[i].participated / props.Data[i].registered) * 100).toFixed(1)
      : 0);
  }

  const colors = values.map((value) => {
    if (value >= 90) return "#6366F1";
    if (value >= 60) return "#F97316";
    return "#EF4444";
  });

  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: colors,
        borderRadius: 8,
        borderSkipped: false,
        barThickness: 95,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
  layout: {
    padding: {
      top: 30,
    },
  },
    plugins: {
      legend: {
        display: false,
      },

      tooltip: {
  enabled: true,

  callbacks: {
    title: (tooltipItems) => {
      const item = props.Data?.[tooltipItems[0].dataIndex];
      return `Grade ${item?.grade}`;
    },

    label: (context) => {
      const item = props.Data?.[context.dataIndex];

      if (!item) return "";

      return [
        `Percentage: ${context.raw}%`,
        `Participated: ${item.participated}`,
        `Total Registered: ${item.registered}`,
      ];
    },
  },
},

      datalabels: {
          display: true,
  anchor: "end",
  align: "top",
  offset: 6,
  clamp: true,
  clip: false,

        formatter: (value) => `${value}%`,

        color: "#475569",

        font: {
          weight: "bold",
          size: 16,
        },
      },
    },

    scales: {
      y: {
        beginAtZero: true,
        max: 100,

        ticks: {
          stepSize: 10,
        },

        grid: {
          color: "#E5E7EB",
        },
      },

      x: {
        grid: {
          color: "#F1F5F9",
        },
      },
    },
  };

  return (
    <div className="Card mt-3" >

      <div className="grade-header">

        <div>
          <h2>Grade-wise Participation</h2>

          <p>
            Percentage of student participation per grade (Click on a bar to
            view students)
          </p>
        </div>

        <div className="legend-box">

          <div>
            <span className="dot" style={{backgroundColor:"#6366f1"}}></span>
            ≥ 90% (Excellent)
          </div>

          <div>
            <span className="dot" style={{backgroundColor:"#f97316"}}></span>
            60% - 89% (Average)
          </div>

          <div>
            <span className="dot" style={{backgroundColor:"#ef4444"}}></span>
            &lt; 60% (Low)
          </div>

          <hr />

          <div>
            <span className="target-line"></span>
            75% Target
          </div>

        </div>

      </div>

      <div style={{ width: "96%",height:"400px" }}>
        <Bar
          data={data}
          options={options}
          plugins={[targetLine]}
        />
      </div>

    </div>
  );
}
export default GradeWiseParticipation;